const FundingSources = () => {
  
  const container = '#funding-pie-chart';

  const data = [
    { type: 'taxes', value: 81 },
    { type: 'state park fees', value: 9 },
    { type: 'development fees', value: 4.5 },
    { type: 'wastewater surcharge', value: 4.5 },
    { type: 'other', value: 1 },
  ];

  const width = 500;
  const height = Math.min(width, 500);
  const radius = Math.min(width, height) / 2;

  const color = d3.scaleOrdinal(d3.schemeCategory10);

  const pie = d3.pie().value(d =>  d.value );

  const arc = d3.arc()
    .innerRadius(radius - 100)
    .outerRadius(radius - 20);

  const svg = d3.select(container).append('svg')
    .attr('width', width)
    .attr('height', height)
    .style("margin-left", '8%')
    .append('g')
      .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
  
  const path = svg.datum(data).selectAll('path')
      .data(pie)
    .enter().append('path')
      .attr('fill', (d, i) => color(i))
      .attr('d', arc)
      .each(function(d) { this._current = d; }); // store the initial angles
  
  const text = svg.selectAll("text")
    .data(pie)
    .enter().append("text")
      .attr("transform", d => `translate(${arc.centroid(d)})`)
      .attr("dy", "0.35em");
  
  text.append("tspan")
    .attr("x", "-0.4em")
    .attr("y", 0)
    .style("font-weight", "bold")
    .style('font-size', '1.4rem')
    .style('text-align', 'center')
    .style('fill', '#FFF')
    .text(d => `${d.data.value}%`);
  
  const legend = d3.select(container).append('div')
    .attr("class", "funding-legend");

  const legendItems = d3.select('.funding-legend')
    .selectAll(".funding-legend-item").data(data);

  legendItems.enter()
    .append("div").attr("class", "funding-legend-item")
    .style("margin-top", "25px");
  
    d3.selectAll('.funding-legend-item').append('div')
    .attr("class", 'funding-legend-rect')
    .style("width", "40px")
    .style("height", "20px")
    .style("background-color", function (d, i) {
      return color(i)
    })

  d3.selectAll('.funding-legend-item').append('div')
    .attr("class", 'funding-legend-text')
    .text(d => d.type);
};

const FundingSplit = () => {
  
  const container = '#funding-pie-chart';

  const data = [
    { type: 'Pollution Abatement Projects', value: 60 },
    { type: 'Special Projects', value: 40 },
  ];

  const width = 500;
  const height = Math.min(width, 500);
  const radius = Math.min(width, height) / 2;

  const color = d3.scaleOrdinal(d3.schemeCategory10);

  const pie = d3.pie().value(d =>  d.value );

  const arc = d3.arc()
    .innerRadius(radius - 100)
    .outerRadius(radius - 20);

  const svg = d3.select(container).append('svg')
    .attr('width', width)
    .attr('height', height)
    .style("margin-left", '8%')
    .append('g')
      .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
  
  const path = svg.datum(data).selectAll('path')
      .data(pie)
    .enter().append('path')
      .attr('fill', (d, i) => color(i))
      .attr('d', arc)
      .each(function(d) { this._current = d; }); // store the initial angles
  
  const text = svg.selectAll("text")
    .data(pie)
    .enter().append("text")
      .attr("transform", d => `translate(${arc.centroid(d)})`)
      .attr("dy", "0.35em");
  
  text.append("tspan")
    .attr("x", "-0.4em")
    .attr("y", 0)
    .style("font-weight", "bold")
    .style('font-size', '1.4rem')
    .style('text-align', 'center')
    .style('fill', '#FFF')
    .text(d => `${d.data.value}%`);
  
  const legend = d3.select(container).append('div')
    .attr("class", "funding-legend");

  const legendItems = d3.select('.funding-legend')
    .selectAll(".funding-legend-item").data(data);

  legendItems.enter()
    .append("div").attr("class", "funding-legend-item")
    .style("margin-top", "25px");
  
    d3.selectAll('.funding-legend-item').append('div')
    .attr("class", 'funding-legend-rect')
    .style("width", "40px")
    .style("height", "20px")
    .style("background-color", function (d, i) {
      return color(i)
    })

  d3.selectAll('.funding-legend-item').append('div')
    .attr("class", 'funding-legend-text')
    .text(d => d.type);
};

const CIPTable = () => {
  const CIPData = [
    {
      "Project Title": "Cherry Creek Stream Stabilization at Main Street (Parker)",
      "Total": "$1,776",
      "Authority Portion": "$200",
      "Proposed 2019 Budget": "---",
      "Out-year Budget": "$200",
      "Funding Year(s)": 2025
    },
    {
      "Project Title": "Cherry Creek Stream Stabilization at Lincoln Avenue (Parker)",
      "Total": "$1,447",
      "Authority Portion": "$304",
      "Proposed 2019 Budget": "---",
      "Out-year Budget": "$304",
      "Funding Year(s)": 2026
    },
    {
      "Project Title": "Cherry Creek Stream Reclamation – Reach 3",
      "Total": "$2,567",
      "Authority Portion": "$640",
      "Proposed 2019 Budget": "---",
      "Out-year Budget": "$640",
      "Funding Year(s)": "2022-2023"
    },
    {
      "Project Title": "Cherry Creek Stream Reclamation – Reach 4",
      "Total": "$2,720",
      "Authority Portion": "$680",
      "Proposed 2019 Budget": "---",
      "Out-year Budget": "$680",
      "Funding Year(s)": "2020-2022"
    },
    {
      "Project Title": "Cherry Creek Stream Reclamation – CCSP Reach 1",
      "Total": "$2,220",
      "Authority Portion": "$2,220",
      "Proposed 2019 Budget": "$350",
      "Out-year Budget": "$1,770",
      "Funding Year(s)": "2020-2025"
    },
    {
      "Project Title": "Cherry Creek Stream Reclamation upstream of Scott Road (Parker)",
      "Total": "$1,100",
      "Authority Portion": "$170",
      "Proposed 2019 Budget": "$170",
      "Out-year Budget": "---",
      "Funding Year(s)": "---"
    },
    {
      "Project Title": "McMurdo Gulch Reclamation (Castle Rock)",
      "Total": "$1,677",
      "Authority Portion": "$420",
      "Proposed 2019 Budget": "$386",
      "Out-year Budget": "---",
      "Funding Year(s)": "---"
    },
    {
      "Project Title": "Stream Corridor Preservation",
      "Total": "$100",
      "Authority Portion": "$100",
      "Proposed 2019 Budget": "---",
      "Out-year Budget": "$450",
      "Funding Year(s)": "2020-2028"
    },
    {
      "Project Title": "East Boat Ramp Shoreline Stabilization Phase II",
      "Total": "$80",
      "Authority Portion": "$80",
      "Proposed 2019 Budget": "---",
      "Out-year Budget": "$80",
      "Funding Year(s)": 2020
    },
    {
      "Project Title": "East Shade Shelter Shoreline Stabilization Phase II",
      "Total": "$60",
      "Authority Portion": "$60",
      "Proposed 2019 Budget": "---",
      "Out-year Budget": "$60",
      "Funding Year(s)": 2020
    },
    {
      "Project Title": "West Shade Shelter Shoreline Stabilization PRF",
      "Total": "$950",
      "Authority Portion": "$950",
      "Proposed 2019 Budget": "$530",
      "Out-year Budget": "$300",
      "Funding Year(s)": 2020
    },
    {
      "Project Title": "Tower Loop Shoreline Stabilization Phase II",
      "Total": "$100",
      "Authority Portion": "$100",
      "Proposed 2019 Budget": "---",
      "Out-year Budget": "$100",
      "Funding Year(s)": 2020
    },
    {
      "Project Title": "Non-point Pollutant Management",
      "Total": "$100",
      "Authority Portion": "$100",
      "Proposed 2019 Budget": "---",
      "Out-year Budget": "$450",
      "Funding Year(s)": "2020-2028"
    },
    {
      "Project Title": "Lone Tree Creek in CCSP",
      "Total": "$2,800",
      "Authority Portion": "$700",
      "Proposed 2019 Budget": "$65",
      "Out-year Budget": "$635",
      "Funding Year(s)": "2020-2021"
    },
    {
      "Project Title": "Interpretive PRF Signage at 12-Mile Park (2 signs) & West Boat Ram (1 sign)",
      "Total": "$30",
      "Authority Portion": "$30",
      "Proposed 2019 Budget": "---",
      "Out-year Budget": "$30",
      "Funding Year(s)": 2020
    },
    {
      "Project Title": "Total Capital Projects",
      "Total": "$17,727",
      "Authority Portion": "$6,754",
      "Proposed 2019 Budget": "$1,501",
      "Out-year Budget": "$5,699",
      "Funding Year(s)": ""
    },
    {
      "Project Title": "Rehabilitation",
      "Total": "",
      "Authority Portion": "",
      "Proposed 2019 Budget": "$40",
      "Out-year Budget": "$360",
      "Funding Year(s)": "2020-2028"
    },
    {
      "Project Title": "Restorative",
      "Total": "",
      "Authority Portion": "",
      "Proposed 2019 Budget": "$141",
      "Out-year Budget": "$728",
      "Funding Year(s)": "2020-2028"
    },
    {
      "Project Title": "Routine",
      "Total": "",
      "Authority Portion": "",
      "Proposed 2019 Budget": "$81",
      "Out-year Budget": "$983",
      "Funding Year(s)": "2020-2028"
    },
    {
      "Project Title": "Operations",
      "Total": "",
      "Authority Portion": "",
      "Proposed 2019 Budget": "$85",
      "Out-year Budget": "---",
      "Funding Year(s)": "2020-2028"
    },
    {
      "Project Title": "Total Operations and Maintenance",
      "Total": "",
      "Authority Portion": "",
      "Proposed 2019 Budget": "$347",
      "Out-year Budget": "$2,071",
      "Funding Year(s)": "2020-2028"
    },
  ];

  // Declare and configure request overview table
  const table = new requestTable({
    container: "#cip-table",
    filterEnabled: false,
    tableHeaders: {
      'Project Title': 'Project Title',
      'Total': 'Current Total Budget',
      'Authority Portion': 'Current Authority Portion',
      'Proposed 2019 Budget': 'Proposed 2019 Budget',
      'Out-year Budget': 'Out-year Budget',
      'Funding Year(s)': 'Funding Year(s)',
    },
    tableActions: [],
    tableData: CIPData,
  });
  table.buildTable();
};
